import React from 'react';
import { Box, TextField, Button } from '@mui/material';

const PICKUP_STATUS_OPTIONS = [
  { value: 'REQUESTED', label: 'Requested' },
  { value: 'RIDER_ASSIGNED', label: 'Rider Assigned' },
  { value: 'DONE', label: 'Done' },
  { value: 'CANCELED_BY_MERCHANT', label: 'Canceled by Merchant' },
];

type FiltersSectionProps = {
  filters: { date: string; status: string };
  setFilters: (filters: { date: string; status: string }) => void;
  loading: boolean;
  fetchAPI: () => void;
};

const FiltersSection: React.FC<FiltersSectionProps> = ({ filters, setFilters, loading, fetchAPI }) => {
  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      flexWrap="wrap"
      gap={2}
      alignItems="center"
      justifyContent="flex-end"
    >
      <TextField
        type="date"
        label="Date"
        size="small"
        value={filters.date}
        onChange={(e) => setFilters({ ...filters, date: e.target.value })}
        disabled={loading}
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        className="w-full sm:w-auto"
      />
      <TextField
        select
        size="small"
        label="Status"
        value={filters.status}
        onChange={(e) => setFilters({ ...filters, status: e.target.value })}
        disabled={loading}
        variant="outlined"
        SelectProps={{ native: true }}
        InputLabelProps={{ shrink: true }}
        className="w-full sm:w-auto"
      >
        <option value="">All Statuses</option>
        {PICKUP_STATUS_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </TextField>
      <Button variant="contained" color="primary" onClick={fetchAPI} disabled={loading} className="w-full sm:w-auto">
        Search
      </Button>
    </Box>
  );
};

export default FiltersSection;
